import React, { useState } from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import Home from "../pages/home/Home";
import Form from "../components/Quiz/Form";

const Main = (props) => {
  console.log(props.theme);
  const [value1, setvalue1] = useState("");
  const [def1, setdef1] = useState("");
  const [share1, setshare1] = useState("");
  const [value2, setvalue2] = useState("");
  const [def2, setdef2] = useState("");
  const [share2, setshare2] = useState("");

  const [value3, setvalue3] = useState("");
  const [def3, setdef3] = useState("");
  const [share3, setshare3] = useState("");

  const [value4, setvalue4] = useState("");
  const [def4, setdef4] = useState("");
  const [share4, setshare4] = useState("");

  useState(() => {
    let sum1 = props.ans1 + props.ans5 + props.ans7 + props.ans9;

    if (sum1 <= 2) {
      setvalue1("Persistence");
      setdef1("Make something better, today");
      setshare1("Ellevation Education");
    } else if (sum1 <= 6) {
      setvalue1("Sustainability");
      setdef1(
        "We work smartly, take care of our team, and have fun to ensure sustainability and success."
      );
      setshare1("Ellevation Education");
    } else if (sum1 <= 10) {
      setvalue1("Long Game");
      setdef1("Not today, but if we persist we'll get there");
      setshare1("Ellevation Education");
    } else if (sum1 <= 13) {
      setvalue1("Hunger");
      setdef1(
        "We want you to find your comfort zone. And then seek to challenge it, over and over."
      );
      setshare1("SendGrid");
    } else {
      setvalue1("Excellence Is a State of Mind");
      setdef1(
        "We have high standards. We execute on the details. We take pride in our work."
      );
      setshare1("PitchBook");
    }
    let sum2 = props.ans2 + props.ans4 + props.ans11;
    if (sum2 < 3) {
      setvalue2("Trust & Candor");
      setdef2(
        "We build trust through constructive, candid communication that serves the common good."
      );
      setshare2("EagleView Technogolies");
    } else if (sum2 <= 5) {
      setvalue2("Alignment & Accountability");
      setdef2(
        "We align around a decision and each contribute to and are accountable for its success."
      );
      setshare2("EagleView Technogolies");
    } else if (sum2 <= 7) {
      setvalue2("Grow");
      setdef2("Grow our business in a way that makes us proud.");
      setshare2("Twitter");
    } else if (sum2 <= 9) {
      setvalue2("We are owners. ");
      setdef2(
        "Every day, we take initiative—with integrity and courage—to make our company better."
      );
      setshare2("F5 Networks");
    } else {
      setvalue2("Lead");
      setdef2(
        "We’re autonomous. Everyone is empowered to own their work and we minimize unnecessary steps."
      );
      setshare2("IKEA");
    }
    let sum3 = props.ans3 + props.ans6 + props.ans12;
    if (sum3 < 3) {
      setvalue3("Give Joy");
      setdef3(
        "Laugh. Be grateful, positive and hospitable. Make people feel good."
      );
      setshare3("CampMinder");
    } else if (sum3 <= 5) {
      setvalue3("Humble");
      setdef3(
        "While there’s always a time and place to celebrate individual accomplishments, no single person is bigger than the team."
      );
      setshare3("Zappos");
    } else if (sum3 <= 7) {
      setvalue3("Growth & Happiness");
      setdef3(
        "Our success is dependent upon the collective energy, intelligence, and contributions of all."
      );
      setshare3("Whole Foods");
    } else if (sum3 <= 9) {
      setvalue3("Support Each Other");
      setdef3(
        "We are committed to building an encouraging, caring, and supportive environment."
      );
      setshare3("Centro");
    } else {
      setvalue3("Collaborate");
      setdef3(
        "Together we are stronger. We deliver more success through shared goals and mutual support."
      );
      setshare3("Deluxe Entertainment");
    }
    let sum4 = props.ans8 + props.ans10 + props.ans13;
    if (sum4 < 3) {
      setvalue4("Continuous Learning");
      setdef4(
        "We are passionate about learning and seek to constantly improve and innovate."
      );
      setshare4("Ellevation Education");
    } else if (sum4 <= 5) {
      setvalue4("Relentlessness & Humility");
      setdef4(
        "We are relentless in our pursuits of major victories and humble in our successes."
      );
      setshare4("Kellogg’s");
    } else if (sum4 <= 7) {
      setvalue4("Innovative");
      setdef4(
        "We are a perceptual work in progress always striving to be better."
      );
      setshare4("Envoy");
    } else if (sum4 <= 9) {
      setvalue4("We choose speed. ");
      setdef4(
        "We make thoughtful decisions quickly, execute them with intensity, and simplify where we can."
      );
      setshare4("5F Networks");
    } else {
      setvalue4("Be Pioneers");
      setdef4(
        "We innovate and push for boundless creativity through curiosity."
      );
      setshare4("Deluxe Entertainment");
    }
  });
  const [animation, setanimation] = useState(false);
  const clickButton = () => {
    setanimation(true);
  };
  return (
    <div>
      <Form
        ans1={props.ans1}
        ans2={props.ans2}
        ans3={props.ans3}
        ans4={props.ans4}
        ans5={props.ans5}
        ans6={props.ans6}
        ans7={props.ans7}
        ans8={props.ans8}
        ans9={props.ans9}
        ans10={props.ans10}
        ans11={props.ans11}
        ans12={props.ans12}
        ans13={props.ans13}
        clickButton={clickButton}
      />
      <Home
        theme={props.theme}
        value1={value1}
        value2={value2}
        value3={value3}
        value4={value4}
        def1={def1}
        def2={def2}
        def3={def3}
        def4={def4}
        share1={share1}
        share2={share2}
        share3={share3}
        share4={share4}
        animation={animation}
      />
    </div>
  );
};

export default Main;
